import { useEffect, useRef, type ReactNode } from "react";
import { Icon } from "./Icon";

/* W93 — THE REVIEW'S MEDIA STAGE (his word, 2026-09-28): a video opens "as a window middle screen, kinda big … blurring,
 * dimming or both, its background … needs an x button but also to be able to click out of the video container to
 * dismiss it". The coach's own round video opens in the same stage, CIRCULAR ("the video can open in a circular window").
 *
 * A modal `<dialog>` — the browser makes the page behind inert and puts this in the top layer, above an open window too
 * (the overview window opens clips from inside its own dialog). Escape closes (the dialog's own `cancel`). A click whose
 * target is the dialog ITSELF is a click on the dimmed area: the stage's content is a child, so a click on the video never
 * reaches that test. Closing unmounts, which stops the video. */
export function MediaStage({ shape, label, onClose, children }: {
  shape: "round" | "wide" | "photo"; label: string; onClose: () => void; children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (el !== null && !el.open) el.showModal();
  }, []);
  return (
    <dialog ref={ref} className={`media-stage is-${shape}`} aria-label={label}
            onCancel={(e) => { e.preventDefault(); onClose(); }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="media-stage-box">
        {children}
        <button type="button" className="media-stage-close" onClick={onClose} aria-label="Close">
          <Icon name="x" size={20} />
        </button>
      </div>
    </dialog>
  );
}
